import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import {  transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";


const ProjectDomain = createApi({
    reducerPath:"ProjectDomain",
    baseQuery:customFetchBase,
    endpoints:(builder)=>({
        
        addProjectDomain: builder.mutation({
            query: (data) => ({
              url: '/ProjectDomain/AddProjectDomain', 
              method: 'POST',
              body: transformRequest(data), 
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getProjectDomainById: builder.query({
            query: (projectDomainId) => ({
              url: `/ProjectDomain/GetProjectDomainById?projectdomainId=${Number(projectDomainId)}`,
              method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
          }),
          getAllProjectDomains: builder.mutation({
            query: (queryRequest) => ({
              url: '/ProjectDomain/GetAllProjectDomains', 
              method: 'POST',
              body: transformRequest(queryRequest), 
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
          }),
          updateProjectDomain: builder.mutation({
            query: (data) => ({
              url: '/ProjectDomain/UpdateProjectDomain', 
              method: 'POST',
              body: transformRequest(data), 
            }),
            transformResponse: transformSuccessResponse, 
            transformErrorResponse: transformErrorResponse, 
          }),
          deleteProjectDomain: builder.mutation({
            query: (projectDomainId) => ({
              url: `/ProjectDomain/DeleteProjectDomain?ProjectDomainId=${projectDomainId}`, 
              method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse, 
            transformErrorResponse: transformErrorResponse, 
          }),
      
    }),
})
export const {
    useAddProjectDomainMutation,
    useLazyGetProjectDomainByIdQuery,
    useGetAllProjectDomainsMutation,
    useUpdateProjectDomainMutation,
    useDeleteProjectDomainMutation,
  } = ProjectDomain;
  
  export default ProjectDomain;
  